module.exports = __webpack_public_path__ + "img/54.7e86f94d.jpg";